import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

/**
 * OtherCategoryNotice
 *
 * Shown at the top of the analysis panel when a call is categorized as
 * "other" (personal / internal / non-customer conversation) and its profile
 * produced no quality score. Since the 2026-06-29 quality audit the default
 * "other" profile intentionally suppresses all agent-coaching/QA and sales
 * metrics — without this notice the scoreless card reads as a broken analysis.
 */
export function OtherCategoryNotice() {
  const { t } = useTranslation(['records']);

  return (
    <div
      data-testid="other-category-notice"
      className={cn(
        'rounded-card border border-info bg-info-dim p-3',
        'flex items-start gap-3'
      )}
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-info" />
      <div className="space-y-1">
        <p className="text-sm font-medium text-fg">
          {t('records.otherCategoryNotice.title', 'No quality scores for this category')}
        </p>
        <p className="text-xs leading-relaxed text-fg-muted">
          {t(
            'records.otherCategoryNotice.body',
            'This record was categorized as “Other” — a personal or internal conversation without a customer. Such records get a descriptive analysis only (summary, sentiment); quality scores are intentionally not produced. If the category looks wrong, re-run the analysis.'
          )}
        </p>
      </div>
    </div>
  );
}
